export default __webpack_public_path__ + "static/media/apprenticeship.90b02114.svg";